// extracted by mini-css-extract-plugin
export default {"headerWrapper":"webinar-page_headerWrapper__7Uuxc","searchField":"webinar-page_searchField__sX82n","toggleWrapper":"webinar-page_toggleWrapper__7fYY-"};